import React, { useState } from 'react';
import { Button, Modal } from 'react-bootstrap';
import apiFetch from '../../../utils/apiFetch';
import { notify } from '../../../utils/notification';
import { spellWalls } from '../../../shared/rules/effects/spellWalls.mjs';

const sectionsOf = wall => [...(wall.edges || []).map(edge => { const [x, y, direction] = edge.split(','); return { key: edge, x1: Number(x), y1: Number(y), x2: Number(x) + (direction === 'h' ? 1 : 0), y2: Number(y) + (direction === 'h' ? 0 : 1) }; }),
  ...(wall.cells || []).map(({ x, y }) => ({ key: `${x},${y}`, x1: x + .5, y1: y + .5, x2: x + .5, y2: y + .5 }))];

// Breaking a wall is the DM's call: click a section to take it away. Hit Points stay at the table.
export default function DmSpellWallsTool({ campaignId, combatState, onUpdated, renderTrigger }) {
  const [open, setOpen] = useState(false);
  const walls = spellWalls(combatState?.activeEffects);
  const remove = async (wall, section) => {
    try {
      const response = await apiFetch(`/campaigns/${encodeURIComponent(campaignId)}/buffs/wall-section`, { method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: `wall-section:${wall.id}:${section}:${Date.now()}`, effectId: wall.id, section }) });
      const result = await response.json();
      if (!response.ok) throw new Error(result.message || 'The section could not be removed.');
      onUpdated?.(result.combat);
    } catch (failure) { notify(failure.message, 'danger'); }
  };
  return <>
    {renderTrigger(() => setOpen(true))}
    <Modal show={open} onHide={() => setOpen(false)} centered className="dnd-modal modern-modal" aria-label="Spell walls">
      <Modal.Header closeButton><Modal.Title>Spell walls</Modal.Title></Modal.Header>
      <Modal.Body>
        {!walls.length && <p>No spell walls are up.</p>}
        {walls.map(wall => {
          const sections = sectionsOf(wall);
          const xs = sections.flatMap(item => [item.x1, item.x2]), ys = sections.flatMap(item => [item.y1, item.y2]);
          const left = Math.min(...xs) - 1, top = Math.min(...ys) - 1, width = Math.max(...xs) - left + 1, height = Math.max(...ys) - top + 1;
          return <div key={wall.id} className="mb-3">
            <p className="mb-1">{wall.name}: click a section to remove it.</p>
            <svg role="img" aria-label={`${wall.name} sections`} viewBox={`${left} ${top} ${width} ${height}`} style={{ width: '100%', maxHeight: 200 }}>
              {sections.map(item => <line key={item.key} role="button" tabIndex={0} aria-label={`Remove section ${item.key}`} x1={item.x1} y1={item.y1} x2={item.x2 + (item.x1 === item.x2 && item.y1 === item.y2 ? .01 : 0)} y2={item.y2} stroke="#ffb347" strokeWidth=".5" strokeLinecap="round" style={{ cursor: 'pointer' }}
                onClick={() => remove(wall, item.key)} onKeyDown={event => { if (event.key === 'Enter') remove(wall, item.key); }} />)}
            </svg>
          </div>;
        })}
      </Modal.Body>
      <Modal.Footer><Button variant="secondary" onClick={() => setOpen(false)}>Close</Button></Modal.Footer>
    </Modal>
  </>;
}
